import React from 'react';
import { BrowserRouter as Router, Switch } from "react-router-dom";
import routes from '../../config/router'
import RouteWithSubRoutes from 'components/routeWithSubRoutes';
import { Container, Box } from '@mui/material';
import queryString from 'query-string';
import * as keycloakAuthentication from '../../keycloak'

export default function App(this: any) {
    const parsedQuery = queryString.parse(window.location.search);
    //set clientId
    if (parsedQuery.clientId !== null && parsedQuery.clientId !== undefined)
        keycloakAuthentication.setClientId(parsedQuery.clientId)

    function onSuccess(loggedIn: Boolean) {
        if (loggedIn) {
            console.log('Successfully logged in...');
        } else {
            console.log('Not logged in.');
        }
    }

    function onError() {
        console.log('Something went wrong during authentication. Please try again.');
    }


    React.useEffect(() => {

        let url = window.location.pathname
        let urlParts = url.split('/');
        let page = urlParts.length > 1 ? urlParts[1].toLowerCase() : "unknown"
        console.log(`Page: ${page}`)
        switch (page.toLowerCase()) {
            case "authenticate":
                keycloakAuthentication.checkAuthenticated((authenticated: Boolean) => {
                    if (authenticated) {
                        onSuccess(true);
                        keycloakAuthentication.authenticationSuccess(authenticated, "AUTHENTICATE");
                    } else {
                        keycloakAuthentication.login(onSuccess, onError);
                    }
                }, onError);
                break;
            case "checkauthenticated":
                keycloakAuthentication.checkAuthenticatedAndNotifyParent(onSuccess, onError);
                break;
            case "logout":
                keycloakAuthentication.logout();
                break;

            default:
                break;
        }


    }, [])
    return (

        <React.Fragment>
            <Container fixed maxWidth='sm'>
                <Router>
                    <Box
                        sx={{
                            height: '100vh',
                        }}
                    >
                        <Switch>
                            {routes.map((route, i) => (
                                <RouteWithSubRoutes key={i} {...route} />
                            ))}
                        </Switch>
                    </Box>
                </Router>
            </Container>
        </React.Fragment>

    )


}

